export default __webpack_public_path__ + "static/Jardim-b56f4a463c5c4eedd4f77d3532ab99f4.svg";